import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "@/auth/shared";
import { title } from "@/components/base/primitives";
import { ChangePasswordForm } from "@/components/users/change-password-form";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/account/change-password")({
  head: () => ({
    meta: [{ title: "Change Password" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const viewer = useViewer();

  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 text-center">
        <h1 className={title({ size: "lg" })}>Change Password</h1>
      </div>

      {viewer?.needsPasswordChange && (
        <p className="mx-auto max-w-md text-center">
          You were given a temporary password. You need to create a new one
          before using your account.
        </p>
      )}

      <ChangePasswordForm
        className="mx-auto w-full max-w-sm rounded-lg bg-white p-8"
        isTemp={viewer?.needsPasswordChange}
      />
    </DefaultLayout>
  );
}
